var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.isMobile)?_c('IndexM'):_c('IndexP'),_c('NavigatorBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }